import { render, staticRenderFns } from "./CourseAssessment.vue?vue&type=template&id=50e30661&scoped=true&"
import script from "./CourseAssessment.vue?vue&type=script&lang=js&"
export * from "./CourseAssessment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e30661",
  null
  
)

export default component.exports